// Module
var code = `<label class="anchor-label">Snapshot as of:</label>
<div class="snapshot-selector">
  <select class="snapshot-select">
    <option value="">Select snapshot date...</option>
  </select>
</div>
`;
// Exports
export default code;